import { observer } from "mobx-react-lite";
import type { PropsWithChildren } from "react";
import { AudioCaptureActionsContextProvider } from "./audio-capture-actions.context";
import type { AudioCaptureActionsProviderProps } from "./audio-capture-actions.types";
import { useAudioCaptureActionsContextValue } from "./audio-capture-actions.hooks";

export const AudioCaptureActionsProvider = observer(function AudioCaptureActionsProvider({
  children,
  noteId,
  onRequestClose,
  adapters,
}: PropsWithChildren<AudioCaptureActionsProviderProps>) {
  const value = useAudioCaptureActionsContextValue({ noteId, onRequestClose, adapters });

  return (
    <AudioCaptureActionsContextProvider value={value}>
      {children}
    </AudioCaptureActionsContextProvider>
  );
});
